import { MutableRefObject } from 'react';

type InitWigtetArgs = {
    widgetPath: string;
    widgetId: string;
    target: HTMLDivElement|null;
    options?: Record<string, any>|null;
}

export function initWidget({
    widgetPath,
    widgetId,
    target,
    options = null,
}: InitWigtetArgs): void {
    if (typeof window.createWidgetFrame !== 'function' || !target || !widgetPath || !widgetId) {
        return;
    }

    const host = process.env.NODE_ENV === 'development' ? 'https://dev-broadcast.comdi.com' : 'https://broadcast.comdi.com';

    window.createWidgetFrame(
        target,
        `${host}${widgetPath}`, 
        {
            widgetKey: widgetId,
            ...options,
        }
    );
}
